<template>
  <div class="login-big-box">
    <div class="login-box">
      <div class="bg bg-blur" style="display: none"></div>
      <el-form
        :model="ruleForm2"
        :rules="rules2"
        ref="ruleForm2"
        label-position="left"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <h3 class="title">快手阿修购物商城</h3>
        <el-form-item prop="account">
          <el-input
            type="text"
            v-model="ruleForm2.account"
            auto-complete="off"
            placeholder="账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input
            v-model="ruleForm2.checkPass"
            auto-complete="off"
            show-password
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <!-- <ewidth: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff; -->

        <el-form-item style="width: 100%">
          <el-button
            type="primary"
            style="width: 100%"
            @click.native.prevent="handleSubmit2"
            :loading="logining"
            >{{ loginStr }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {requestLogin} from "../api/api"
export default {
  data(){
    return{
      loginStr: "登录",
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: "",
      },
      rules2: {
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
        ],
        checkPass: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
      },
      checked: false,
    }
  },
  methods: {
    handleSubmit2(){
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          var loginParams = {
            mobile: this.ruleForm2.account,
            password: this.ruleForm2.checkPass,
          };
          this.loginStr = "登录中...";
          requestLogin(loginParams).then((data) => {
            if (!data.success) {
              this.$message({
                message: data.msg,
                type: "error",
              });
              this.logining = false;
              this.loginStr = "重新登录";
            } else {
              var token = data.response.token;
              this.$store.commit("saveToken", token);
              this.$store.commit("setLoginType", true)
              // var curTime = new Date();
              // var expiredate = new Date(
              //   curTime.setSeconds(
              //     curTime.getSeconds() + data.response.expires_in
              //   )
              // );
              var expiredate = (new Date().getTime() + data.response.expires_in * 1000) - 10000
              this.$store.commit("saveTokenExpire", expiredate);
              window.localStorage.refreshtime = expiredate;
              window.localStorage.expires_in = data.response.expires_in;
              // this.loginStr = "成功获取Token，等待服务器返回用户信息...";
              this.loginStr = data.msg;
              // this.getUserInfoByToken(token);
              // debugger
              this.$router.push({path:'/home'})
              console.log(this.$route.path)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // this.$router.push('/home')
    }
  }
}
</script>
<style lang="scss" scoped>
.login-big-box{
  margin: 0;
  padding: 100px;
}
.login-box{
    margin: 0 auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
}
</style>